export default __webpack_public_path__ + "static/media/Set3_Board3.ec77371a.png";